export default {
  inject: ['load'],
  data() {
    return {
      allSkinExaminationsForOther: [],
      skinExamination: null,
    };
  },
  methods: {
    getListOfSkinExaminationsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllSkinExaminations').then(() => {
        if (this.$store.state.skinExaminationModule.successFlag) {
          this.allSkinExaminationsForOther =
            this.$store.state.skinExaminationModule.allSkinExaminations;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.skinExaminationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfSkinExaminationsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getSkinExaminationFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getSkinExamination', id).then(() => {
        if (this.$store.state.skinExaminationModule.successFlag) {
          this.skinExamination = this.$store.state.skinExaminationModule.skinExamination;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.skinExaminationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getSkinExaminationFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.skinExaminationModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
